import { z } from 'zod';
import type { FollowupType } from './setup/kanban';

// ---------------------------------------------------------------------------
// Params & Queries
// ---------------------------------------------------------------------------

export const listPendingSchedulesQuery = z.object({
  hub_id: z.string().uuid(),
  conversation_id: z.string().uuid().optional(),
  user_id: z.string().optional(),
});

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export interface PendingScheduleEntry {
  conversation_schedule_id: string;
  schedule_type: string;
  run_at: string;
  message_text: string;
  conversation_id: string | null;
  user_id: string | null;
  hub_id: string;
  hub_type: string;
  agent_id: string | null;
  receiver_type: string;
  followup_order: number | null;
  followup_source: 'kanban' | 'default_open' | 'default_closed' | null;
  followup_type: FollowupType | null;
  end_conversation: boolean;
  sender_type: string | null;
  created_at: string;
  updated_at: string;
}

export interface ListPendingSchedulesResponse {
  entries: PendingScheduleEntry[];
  total: number;
}

// ---------------------------------------------------------------------------
// Hub-admin aggregate view (SCHEDULE_INDEX KV)
// ---------------------------------------------------------------------------

export const listHubAggregateSchedulesQuery = z.object({
  hub_id: z.string().uuid(),
  limit: z.coerce.number().int().min(1).max(1000).optional(),
});

export interface HubAggregateScheduleEntry {
  schedule_id: string;
  kind: 'conversation' | 'hub';
  schedule_type: string;
  run_at: string;
  conversation_id: string | null;
}

export interface ListHubAggregateSchedulesResponse {
  entries: HubAggregateScheduleEntry[];
  total: number;
  list_complete: boolean;
}
